// Uncomment the following lines to import the desired Bootstrap JavaScript components

// import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
import Carousel from 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';

import './index.scss';

// Handle navbar background color when scrolling away from top of page
// and hide or show the scroll down indicator
document.addEventListener('DOMContentLoaded', function() {
  const navbar = document.querySelector('.navbar');
  const scrollDownIndicator = document.getElementById('scroll-down-indicator');

  if (!navbar) return;

  const sentinel = document.createElement('div');
  sentinel.style.position = 'absolute';
  sentinel.style.top = '50px';
  sentinel.style.height = '1px';
  sentinel.style.width = '1px';
  document.body.prepend(sentinel);

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        navbar.classList.remove('bg-dark', 'border-bottom', 'border-dark', 'shadow');
        if (scrollDownIndicator) scrollDownIndicator.style.opacity = '1';
      } else {
        navbar.classList.add('bg-dark', 'border-bottom', 'border-dark', 'shadow');
        if (scrollDownIndicator) scrollDownIndicator.style.opacity = '0';
      }
    },
    { threshold: 0 }
  );

  observer.observe(sentinel);

  const carousels = document.querySelectorAll('[id^="carousel-"]');
  carousels.forEach(carousel => {
    new Carousel(carousel, {
      keyboard: true,
      touch: true
    });
  });
});

// Load idea and fund profile PDFs when their respective modals open
document.addEventListener('show.bs.modal', e => {
  const iframe = (e.target as HTMLElement).querySelector<HTMLIFrameElement>('iframe[data-src]');
  if (iframe?.dataset.src) iframe.src = iframe.dataset.src;
});
